<app-overlay-pop-up
   data-qa="overlay-pop-up"
   [openOnHover]="false"
   [isDisabled]="false"
   [overlayContentClass]="overlayContentClass"
   [blockRepositioning]="blockRepositioning">
  <div data-qa="overlay-trigger"
       overlay-trigger
       class="{{outerClass}} hover-wrapper select-container width-inherit"
       [class.control-shrinked-container]="isShrinked">
    <span
      *ngIf="props.title"
      data-qa="props-title"
      class="input-title {{props.titleColorClass ?? 'black-12'}}">
      {{props.title}}<span *ngIf="props.required" class="red-10">*</span>
    </span>
    <div data-qa="selected-item-text"
         class="control space-between-horizontal cursor-pointer"
         (click)="showCheckboxSelector=true; calculateItemsChecked()">
         @if (items.length) {
          <span class="whitespace-nowrap">{{customText ?? selectedItemsText | linkShort:  MAX_TEXT_LEN}}</span>
         } @else {
          <span class="whitespace-nowrap">{{'-'}}</span>
         }
      <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-size-1p25; suffix'"></app-all-icons>
    </div>
  </div>

  <div data-qa="overlay-content" overlay-content>
    <div data-qa="overlay-dropdown" class="overlay-dropdown">
      <div data-qa="overlay-list" class="overlay-list">
        <div data-qa="list-block" class="list-block overflow-x-hidden">
          <div
            *ngIf="props.isSelectAllEnabled"
            data-qa="list-entry"
            class="list-entry flex flex-col items-start justify-center column-gap-0p5 w-full"
            (click)="changeAllSelected(allValuesCheckedText); $event.stopPropagation()">
            <div
              data-qa="check-box-selector-select-unselect-all"
              class="start-row-container upper-text-button font-4 pd-top-0p2">
              @if (items.length) {
                <span class="whitespace-nowrap w-full main-8">{{allValuesCheckedText ?? selectedItemsText | linkShort:  MAX_TEXT_LEN}}</span>
              } @else {
                <div class="w-full py-0.15625 cursor-default">{{props.emptyArrayText}}</div>
              }
            </div>
          </div>
          <ng-container *ngFor="let s of items">
            <div [attr.data-qa]="'entry-container-' + s.item"
                 class="start-column-container">
              <div
                *ngIf="!s.isHidden"
                data-qa="entry"
                class="list-entry start-row-container overflow-x-hidden whitespace-nowrap w-full"
                [class.not-in-table]="isNotInTable"
                (click)="$event.stopPropagation(); changeSelection(s)">
                <app-checkbox
                  data-qa="checkbox"
                  [checked]="s.chosen"
                  [disabled]="s.disabled"
                  (click)="$event.stopPropagation()"
                  (change)="changeSelection(s)"/>
                <span data-qa="name" [class.disabled]="s.disabled" [innerHTML]="s.item">{{s.item | linkShort: props.maxLength}}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</app-overlay-pop-up>
